<template>
  <div class="chips-selector py-6 pt-md-6 pb-md-3 d-flex flex-md-wrap" :class="{'overflow-x': this.$vuetify.breakpoint.xsOnly}" v-if="options">
    <div
      :data-testid="`chip-${chip.id}`"
      class="chip ms-3 mb-md-3 px-5 text-center"
      :style=" [chip.id == selected ? {background: brandColor} : '' ]"
      :class="{'selected': chip.id == selected}"
      v-for="chip in options"
      @click="actionClicked(chip)"
      :key='chip.id'>
      <div class="chip-background-mask"></div>
      <span>{{$t(chip.label)}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ChipsSelector",
    props: {
      options: {type: Array, required: true},
      selected: {type: String, required: true},
      brandColor: {type: String}
    },
    methods:{
      actionClicked(chip) {
        this.$emit('optionSelected', chip)
      }
    }
  };
</script>
<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .chips-selector{
    &.overflow-x{
      @include hide-scrollbar;
      overflow-x: scroll;
      scroll-snap-type: x proximity;
      clip-path: inset(0 0 24px 0);

    }
    .chip{
      height: 32px;
      border-radius: 16px;
      background-color: $core-neutral-400;
      font-family: var(--primary-font-family);
      font-weight: 500;
      font-size: 14px;
      color: $color_dark_text;
      line-height: 32px;
      cursor: pointer;
      flex-shrink: 0;
      position: relative;
      span{
        z-index: 2;
      }
      &.selected{
        background: $brand_secondary_color;
        color: $white_bg;
        font-weight: 700;
      }
    }
  }
  // hover and active
  @media (hover: hover) {
    .chip-background-mask{
      .chips-selector .chip:hover & , .chips-selector .chip:active & {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        border-radius: 16px;
        z-index: 1;
        background: #000000;
      }
      .chips-selector .chip:not(.selected):hover &{
        opacity: 0.07;
      }
      .chips-selector .chip:not(.selected):active &{
        opacity: 0.2;
      }
      .chips-selector .chip.selected:hover &{
        background: #ffffff;
        opacity: 0.24;
      }
      .chips-selector .chip.selected:active &{
        background: #ffffff;
        opacity: 0.36;
      }
    }
  }

</style>
